import * as React from "react"

import { Eye, EyeOff } from "lucide-react"

import { cn } from "@/shared/shadcn/lib/utils"

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  classNameParent?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, classNameParent, type, ...props }, ref) => {
    const [showEye, setShowEye] = React.useState<boolean>(false)
    return (
      <div className={cn("relative", classNameParent)}>
        <input
          ref={ref}
          className={cn(
            "flex h-10 w-full border-[1.2px] border-[#A6A6A6] px-3 py-2 text-sm outline-none file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50 placeholder:text-xs",
            className
          )}
          style={{ borderRadius: "8px" }}
          type={showEye ? "text" : type}
          {...props}
        />
        {type === "password" && (
          <div className="absolute right-2 2xl:top-[7px] top-[12px]">
            {showEye ? (
              <Eye
                className="cursor-pointer 2xl:w-6 2xl:h-6 w-4 h-4"
                color="#A6A6A6"
                onClick={() => setShowEye(!showEye)}
              />
            ) : (
              <EyeOff
                className="cursor-pointer 2xl:w-6 2xl:h-6 w-4 h-4"
                color="#A6A6A6"
                onClick={() => setShowEye(!showEye)}
              />
            )}
          </div>
        )}
      </div>
    )
  }
)
Input.displayName = "Input"

export { Input }
